import React, { Component } from 'react';

import * as yup from 'yup';
import Modal, {
  ModalAction,
  ModalBody,
  ModalButton,
  ModalHeader,
} from '../../../../components/Modal/Modal';
import { trans } from '../../../../localization/index';
import WalletRestaurantInfo from '../components/WalletRestaurantInfo';
import {
  clearSpecialCharacters,
  isEmpty,
  validateEmail,
  validatePhone,
} from '../../../../utils/utils';

const stateData = {
  restaurant: { value: 0, label: '' },
  restaurantName: '',
  restaurantPhone: '',
  restaurantAddress: '',
  restaurantEmail: '',
  customerName: '',
  airpayContact: false,
  isSubmit: false,
};

class AddRestaurantWalletModal extends Component {
  state = stateData;

  componentDidUpdate(prevProps) {
    this.handleOpenDialog(prevProps);
  }

  handleOpenDialog = (prevProps = {}) => {
    const { walletRestaurant } = this.props;
    const { walletRestaurant: oldWalletRestaurant } = prevProps;
    // check change state from close -> open
    if (
      !oldWalletRestaurant.isOpenAddRestaurantDialog &&
      walletRestaurant.isOpenAddRestaurantDialog
    ) {
      this.resetState();
    }
  };

  resetState = () => {
    const intStateData = { ...stateData };
    this.setState({
      ...intStateData,
      customerName: this.props.user.name,
    });
  };

  handleChangeInput = (stateObj) => {
    this.setState(stateObj);
  };

  handleChangeRestaurant = (value) => {
    const { restaurant } = this.state;
    if (value === null || value.value !== restaurant.value) {
      const {
        airpay_contract: airpayContact = false,
        name,
        email,
        phone,
        address,
      } = value.data;
      const restaurantPhone = clearSpecialCharacters(phone);
      this.setState({
        restaurant: value,
        airpayContact,
        restaurantName: name,
        restaurantPhone: validatePhone(restaurantPhone) ? restaurantPhone : '',
        restaurantAddress: address,
        restaurantEmail: validateEmail(email) ? email : '',
      });
    }
  };

  handleCreateWallet = () => {
    const {
      setGeneralError,
      addRestaurantUserWallet,
      walletRestaurant,
    } = this.props;
    const { isSubmit } = this.state;

    if (!isSubmit) {
      this.setState({
        isSubmit: true,
      });
    }

    const { airpayStoreId } = walletRestaurant;
    function validate(reqParam, dispatchGeneralError) {
      const { restaurant_phone: restaurantPhone } = reqParam;
      const requiredMessage = trans('mwl_required_fill_information');
      const schema = yup.object().shape({
        airpay_store_id: yup.number().required(requiredMessage),
        restaurant_id: yup
          .number()
          .min(1, trans('mwl_choose_restaurant'))
          .required(requiredMessage),
        restaurant_name: yup
          .string()
          .required(requiredMessage)
          .test(
            'len',
            trans('mwl_invalid_restaurant_name'),
            val => val.length >= 2 && val.length <= 256,
          ),
        restaurant_address: yup
          .string()
          .required(requiredMessage)
          .test(
            'len',
            trans('mwl_invalid_address'),
            val => val.length >= 10 && val.length <= 100,
          ),
        restaurant_email: yup
          .string()
          .email('mwl_invalid_email')
          .test('len', trans('mql_invalid_email'), val => val.length <= 100),
        customer_name: yup
          .string()
          .test(
            'len',
            trans('mwl_invalid_customer_name'),
            val => val.length === 0 || (val.length >= 2 && val.length <= 64),
          ),
      });
      try {
        schema.validateSync(reqParam);
        if (!isEmpty(restaurantPhone) && !validatePhone(restaurantPhone)) {
          dispatchGeneralError('merchant_phone_invalid');
          return false;
        }
        return true;
      } catch (err) {
        dispatchGeneralError(err.message);
        return false;
      }
    }

    function genBody(state) {
      const {
        restaurant,
        restaurantName,
        restaurantPhone,
        restaurantAddress,
        restaurantEmail,
        customerName,
      } = state;
      const reqParam = {
        airpay_store_id: airpayStoreId,
        restaurant_id: restaurant.value,
        restaurant_name: restaurantName,
        restaurant_address: restaurantAddress,
        restaurant_email: restaurantEmail,
        customer_name: customerName,
        restaurant_phone: clearSpecialCharacters(restaurantPhone),
      };
      return reqParam;
    }

    const reqParam = genBody(this.state);
    if (validate(reqParam, setGeneralError)) {
      addRestaurantUserWallet(reqParam);
    }
  };

  render() {
    const {
      walletRestaurant,
      unlinkedRestaurants,
      closeAddRestaurantUserWallet,
    } = this.props;
    const {
      restaurant,
      restaurantName,
      restaurantPhone,
      restaurantAddress,
      restaurantEmail,
      customerName,
      airpayContact,
      isSubmit,
    } = this.state;
    const { isOpenAddRestaurantDialog } = walletRestaurant;
    return (
      <React.Fragment>
        <Modal
          isOpen={isOpenAddRestaurantDialog}
          onRequestClose={closeAddRestaurantUserWallet}
          className="edit-merchant-form"
        >
          <ModalHeader>
            {trans('merchant_wallet_add_restaurant_wallet')}
          </ModalHeader>
          <ModalBody>
            <p className="title-block">
              {trans('merchant_wallet_add_restaurant_info')}
            </p>
            <WalletRestaurantInfo
              restaurant={restaurant}
              restaurantName={restaurantName}
              restaurantPhone={restaurantPhone}
              restaurantAddress={restaurantAddress}
              restaurantEmail={restaurantEmail}
              customerName={customerName}
              handleChangeRestaurant={this.handleChangeRestaurant}
              unlinkedRestaurants={unlinkedRestaurants}
              airpayContact={airpayContact}
              isSubmit={isSubmit}
              handleChangeInput={this.handleChangeInput}
            />
          </ModalBody>
          <ModalAction>
            <ModalButton type="cancel" onClick={closeAddRestaurantUserWallet}>
              {trans('common_close')}
            </ModalButton>
            <ModalButton styleType="red" onClick={this.handleCreateWallet}>
              {trans('merchant_wallet_add')}
            </ModalButton>
          </ModalAction>
        </Modal>
      </React.Fragment>
    );
  }
}

export default AddRestaurantWalletModal;



// WEBPACK FOOTER //
// ./foody/src/pages/MerchantWallet/WalletManagement/AddRestaurantWallet/AddRestaurantWalletModal.jsx